var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimestop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1617",
    d: "M0-682.665H49.335v49.335H0Z",
    transform: "translate(0 682.665)",
    fill: "#0a64f9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1611",
    transform: "translate(938.665 1113.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1613",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1615",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1621",
    transform: "translate(33.051 1.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1623",
    d: "M0-63.086V-68",
    transform: "translate(0 68)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1625",
    transform: "translate(1.927 1.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1627",
    d: "M-449.021,0H-484",
    transform: "translate(483.999)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1629",
    transform: "translate(32.858 42.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1631",
    d: "M0,0V5.011",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1633",
    transform: "translate(5.685 1.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1635",
    d: "M0-583.851V-592.9a13.661,13.661,0,0,1,13.636-13.687h0A13.661,13.661,0,0,1,0-620.279v-9.053",
    transform: "translate(0 629.332)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1637",
    transform: "translate(1.927 47.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1639",
    d: "M-446.547,0h-34.785",
    transform: "translate(481.332)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1641",
    transform: "translate(13.394 13.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1643",
    d: "M-123.7,0h-9.636",
    transform: "translate(133.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1645",
    transform: "translate(13.394 34.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1647",
    d: "M0-61.849l4.057-4.028a2.723,2.723,0,0,1,3.835,0l4.057,4.028",
    transform: "translate(0 66.667)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1649",
    transform: "translate(26.209 14.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1651",
    d: "M-136.067-272.134a10.6,10.6,0,0,0,10.6-10.6,10.6,10.6,0,0,0-10.6-10.6,10.6,10.6,0,0,0-10.6,10.6A10.6,10.6,0,0,0-136.067-272.134Z",
    transform: "translate(146.666 293.333)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1653",
    transform: "translate(36.809 20.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1655",
    d: "M0,0V4.047H3.373",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestop);
export default __webpack_public_path__ + "static/media/timestop.82db204282673d3738547d62ba3342da.svg";
export { ForwardRef as ReactComponent };